<div class="dropdown" (clickOutside)="onCancel()">
  <button pButton type="button" (click)="setFilter()"
    class="btn btn-default btn-xs " icon="fa fa-filter" iconPos="left"
    data-toggle="dropdown" label="{{ 'Filters' | translate }}"
    style="margin-left: 5px; height: 30px;">
  </button>

  <ul class="dropdown-menu" [ngStyle]="{'display': styleFlag ? 'block' : 'none' }"
      (click)="$event.stopPropagation();">
        <li class="form-group"
            *ngIf="getGraph_item(['sales', 'service','experience','case','attention','financial', 'survey','TDStats', 'TDStatsDR', 'NPSg','BCXg'])">
        <label class="col-sm-3">{{ 'Country' | translate }}:</label>
        <div class="col-sm-9">
          <select class="form-control" [ngModel]="country_id"
              (ngModelChange)="onSelectCountry($event)" name="country">
              <option value=null><span>---</span></option>
              <option *ngFor="let country of countries"
                value={{country.id}}>
                <span>{{country.name}}</span>
              </option>
          </select>
        </div>
        </li>
        <li *ngIf="getGraph_item(['sales', 'service','experience','financial', 'survey'])" class="form-group">
            <label class="control-label col-sm-3">{{ 'Sponsor' | translate }}:</label>
            <div class="col-sm-9">
              <select class="form-control" [ngModel]="sponsor_id"
                  (ngModelChange)="onSelectSponsor($event)" name="sponsor">
                  <option value=null><span>---</span></option>
                  <option *ngFor="let sponsor of sponsors"
                    value={{sponsor.id}}>
                    <span>{{sponsor.name}}</span>
                  </option>
              </select>
            </div>
        </li>
        <li *ngIf="getGraph_item(['sales', 'service','experience','case','attention','financial', 'survey'])" class="form-group">
          <label class="control-label col-sm-3">{{ 'Product' | translate }}:</label>
          <div class="col-sm-9">
            <select class="form-control" [ngModel]="product_id"
                (ngModelChange)="onSelectProduct($event)" name="product">
                <option value=null><span>---</span></option>
                <option *ngFor="let product of products"
                  value={{product.id}}>
                  <span>{{product.name}}</span>
                </option>
            </select>
          </div>
        </li>
        <li *ngIf="getGraph_item(['sales', 'survey'])" class="form-group">
          <label class="control-label col-sm-3">{{ 'Plan' | translate }}:</label>
          <div class="col-sm-9">
            <select class="form-control" [ngModel]="plan_id"
                (ngModelChange)="onSelectPlan($event)" name="product">
                <option value=null><span>---</span></option>
                <option *ngFor="let plan of plans"
                  value={{plan.id}}>
                  <span>{{plan.name}}</span>
                </option>
            </select>
          </div>
        </li>
        <li *ngIf="getGraph_item(['service','experience','case','attention','financial'])" class="form-group">
            <label class="control-label col-sm-3">{{ 'Provider' | translate }}:</label>
            <div class="col-sm-9">
              <select class="form-control" [ngModel]="product_id"
                  (ngModelChange)="onSelectProvider($event)" name="provider">
                  <option value=null><span>---</span></option>
                  <option *ngFor="let provider of providers"
                    value={{provider.id}}>
                    <span>{{provider.name}}</span>
                  </option>
              </select>
            </div>
        </li>
        <li *ngIf="getGraph_item(['service','experience','case'])" class="form-group">
            <label class="control-label col-sm-3">{{ 'Category' | translate }}:</label>
            <div class="col-sm-9">
              <select class="form-control" [ngModel]="category_id"
                  (ngModelChange)="onSelectCategory($event)" name="category">
                  <option value=null><span>---</span></option>
                  <option *ngFor="let category of categories"
                    value={{category.id}}>
                    <span>{{category.name}}</span>
                  </option>
              </select>
            </div>
        </li>
        <li *ngIf="getGraph_item(['service','experience','case'])" class="form-group">
            <label class="control-label col-sm-3">{{ 'Service' | translate }}:</label>
            <div class="col-sm-9">
              <select class="form-control" [ngModel]="service_id"
                  (ngModelChange)="onSelectService($event)" name="service">
                  <option value=null><span>---</span></option>
                  <option *ngFor="let service of services"
                    value={{service.id}}>
                    <span>{{service.name}}</span>
                  </option>
              </select>
            </div>
        </li>
        <li *ngIf="getGraph_item(['survey'])" class="form-group">
            <label class="control-label col-sm-3">{{ 'User' | translate }}:</label>
            <div class="col-sm-9">
              <app-user-select
                (onSelect)="onSelectUser($event)"
                (onClear)="onClearSelectUser()">
              </app-user-select>
            </div>
        </li>
        <li class="form-group">
            <div class="col-sm-offset-3 col-sm-9 div-btn-right">
              <button  class="btn btn-default btn-sm" (click)="onCancel()">
                        {{ 'Cancel' | translate }}
              </button>
              <button  class="btn btn-success btn-sm" (click)="onFilter()">
                        {{ 'Filter' | translate }}
              </button>
            </div>
        </li>
        
  </ul>
</div>
